var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClothing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7596 3.92L28.9996 1C28.9996 3.12173 28.1567 5.15656 26.6564 6.65685C25.1562 8.15715 23.1213 9 20.9996 9C18.8779 9 16.843 8.15715 15.3427 6.65685C13.8424 5.15656 12.9996 3.12173 12.9996 1L4.23959 3.92C3.33436 4.22159 2.56675 4.83683 2.0753 5.65469C1.58385 6.47254 1.40095 7.43913 1.55959 8.38L2.71959 15.32C2.79574 15.7898 3.03695 16.2171 3.39987 16.525C3.76279 16.833 4.22364 17.0014 4.69959 17H8.99959V37C8.99959 39.2 10.7996 41 12.9996 41H28.9996C30.0605 41 31.0779 40.5786 31.828 39.8284C32.5782 39.0783 32.9996 38.0609 32.9996 37V17H37.2996C37.7755 17.0014 38.2364 16.833 38.5993 16.525C38.9622 16.2171 39.2034 15.7898 39.2796 15.32L40.4396 8.38C40.5982 7.43913 40.4153 6.47254 39.9239 5.65469C39.4324 4.83683 38.6648 4.22159 37.7596 3.92Z",
    stroke: "#272626",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothing);
export default __webpack_public_path__ + "static/media/clothing.b2564e886e5542609c5665cad6e888b1.svg";
export { ForwardRef as ReactComponent };